@if (items().length) {
  <nav class="navigation">
    @for (item of items(); track item) {
      @if (item.url) {
        <a
          class="navigation-item"
          uiNavLink
          [link]="item"
          mat-button
          [disableRipple]="true"
        >
          {{ item.label }}
        </a>
      } @else {
        <span class="navigation-item navigation-item-label">
          {{ item.label }}
        </span>
      }
    }
  </nav>
}
